"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "useTheme", {
  enumerable: true,
  get: function get() {
    return _emotionTheming.useTheme;
  }
});

_Object$defineProperty(exports, "ThemeProvider", {
  enumerable: true,
  get: function get() {
    return _emotionTheming.ThemeProvider;
  }
});

var _react = _interopRequireDefault(require("react"));

var _emotionTheming = require("emotion-theming");